import './models'
import JSONAPIClient from './JSONAPIClient'

export default JSONAPIClient
